import React, { FC } from "react";
import { Button } from "@mui/material";
import { ArrowBack, Upload } from "@mui/icons-material";

interface FileActionsProps {
  onBack: () => void;
  onUploadClick: () => void;
  showBackButton: boolean;
  disabled?: boolean;
}

const FileActions: FC<FileActionsProps> = ({
  onBack,
  onUploadClick,
  showBackButton,
  disabled,
}) => {
  return (
    <div style={{ marginBottom: "10px" }}>
      {showBackButton && (
        <Button startIcon={<ArrowBack />} onClick={onBack}>
          Back
        </Button>
      )}
      <Button
        startIcon={<Upload />}
        onClick={onUploadClick}
        disabled={disabled}
      >
        Upload File
      </Button>
    </div>
  );
};

export default FileActions;
